module.exports = __webpack_public_path__ + "static/media/backbase.8cfb8a67.png";